export const buildServiceChip = t => {
  return {
    id: String(t.id),
    name: t.display_name,
    transportReasonId: t.id,
    pickupTimeInSec: t.estimated_at_pick_up_secs || 3600,
    equipment: t.equipment,
  };
};
